import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { device } from 'utils/style'

const Wrapper = styled.div<TSFixMe>`
  margin: -5px -10px;
  flex-direction: block;

  @media ${device.laptop} {
    display: flex;
    flex-wrap: wrap;
  }
`

const Item = styled.div<TSFixMe>`
  margin: 5px 10px;
  display: flex;
  align-items: center;
`

const Indicator = styled.div<TSFixMe>`
  width: 17px;
  min-width: 17px;
  height: 17px;
  min-height: 17px;
  border-radius: 2px;
  margin-right: 10px;
`

const AvailableIndicator = styled(Indicator)`
  background: linear-gradient(#ffffff, #ffffff) 50% 50% / calc(100% - 4px) calc(100% - 4px) no-repeat,
    linear-gradient(90deg, rgba(34, 207, 174, 1) 0%, rgba(192, 103, 255, 1) 100%);
  border-radius: 2px;
  padding: 2px;
  box-sizing: border-box;
`

const OccupiedIndicator = styled(Indicator)<TSFixMe>`
  width: 21px;
  min-width: 21px;
  height: 21px;
  min-height: 21px;
  background-color: #e5e5e5;
`

const SelectedIndicator = styled(Indicator)<TSFixMe>`
  background-color: #1976d2;
  border: 2px solid #1976d2;
`

const Label = styled.div<TSFixMe>`
  color: #5d5c72;
  font-size: 12px;
`

export const SeatsTemplateCaption = (): ReactElement => {
  return (
    <Wrapper>
      <Item>
        <AvailableIndicator />
        <Label>
          <FormattedMessage id="seats.caption.available" defaultMessage="Asiento disponible" />
        </Label>
      </Item>

      <Item>
        <OccupiedIndicator />

        <Label>
          <FormattedMessage id="seats.caption.occupied" defaultMessage="Asiento no disponible" />
        </Label>
      </Item>

      <Item>
        <SelectedIndicator />

        <Label>
          <FormattedMessage id="seats.caption.selected" defaultMessage="Asiento seleccionado" />
        </Label>
      </Item>
    </Wrapper>
  )
}
